import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddRemainingSettings1700134741198 implements MigrationInterface {
	name = 'AddRemainingSettings1700134741198'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "customerAppSettings"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "scheduleSettings"`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "customerApp" json`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "schedule" json`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "reservation" json`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "features" json`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "contact" json`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "kitchen" json`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "kitchen"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "contact"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "features"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "reservation"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "schedule"`)
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "customerApp"`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "scheduleSettings" json NOT NULL`)
		await queryRunner.query(`ALTER TABLE "settings" ADD "customerAppSettings" json NOT NULL`)
	}
}
